import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface reportExportParams {
  tipoRelatorio: number;
  mesInicio: number;
  anoInicio: number;
  mesFim: number;
  anoFim: number;
}
export interface reportScheduleParams {
  tipoRelatorio: number;
  diaEnvio: number;
  periodo: number;
  ativo?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  private _apiPath = 'EstoqueVendas';

  private readonly _http = inject(HttpClient);

  export(params: reportExportParams): Observable<any> {
    return this._http.post<any>(`${environment.apiUrl}/${this._apiPath}/exportar`, params);
  }

  schedule(params: reportExportParams): Observable<any> {
    return this._http.post<any>(`${environment.apiUrl}/AgendamentoRelatorio`, params);
  }

  getByUserId(id: number): Observable<any> {
    return this._http.get<any>(`${environment.apiUrl}/AgendamentoRelatorio/get-by-user-id/${id}`);
  }

  getAll(): Observable<any> {
    return this._http.get<any>(`${environment.apiUrl}/AgendamentoRelatorio/all`);
  }
  
  delete(id: number): Observable<any> {
    return this._http.delete<any>(`${environment.apiUrl}/AgendamentoRelatorio/${id}`);
  }

  getRupturaReport(): Observable<Blob> {

    return this._http.get(`${environment.apiUrl}/NovosFornecedores/break-report`, {
      responseType: 'blob' 
    });
  }

}
